import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from './css/Games.module.css';

const GAMES = [
  {
    to: '/spaceinvaders',
    title: 'Space Invaders',
    year: '1978',
    publisher: 'Taito',
    description:
      'Defend Earth from waves of descending alien invaders. Fire your laser cannon, destroy the squid and crab formations, and protect your bunkers.',
    controls: ['← → Arrow keys to move', 'Space to fire'],
    grid: [
      [0,0,0,1,1,0,0,0],
      [0,0,1,1,1,1,0,0],
      [0,1,1,1,1,1,1,0],
      [1,1,0,1,1,0,1,1],
      [1,1,1,1,1,1,1,1],
      [0,0,1,0,0,1,0,0],
      [0,1,0,1,1,0,1,0],
      [1,0,0,0,0,0,0,1],
    ],
    accentColor: '#38bdf8',
  },
  {
    to: '/manicminer',
    title: 'Manic Miner',
    year: '1983',
    publisher: 'Bug-Byte',
    description:
      'Guide Willy the miner through 20 treacherous caverns, collecting keys to unlock the exit while avoiding deadly guardians and deadly falls.',
    controls: ['← → Arrow keys to move', 'Space / ↑ to jump'],
    grid: [
      [0,1,1,1,0,0,0,0],
      [1,1,1,1,1,0,0,0],
      [1,1,0,1,1,1,0,0],
      [1,1,1,1,1,1,1,0],
      [0,1,1,0,1,1,1,1],
      [0,0,1,1,1,0,1,1],
      [0,0,0,1,1,1,1,0],
      [0,0,0,0,1,1,0,0],
    ],
    accentColor: '#a78bfa',
  },
];

const PIXEL = 5; // px per grid dot in the card icon

const fadeUp = {
  hidden:  { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0  },
};

const GameIcon = ({ grid, color }) => (
  <svg
    width={grid[0].length * PIXEL}
    height={grid.length * PIXEL}
    aria-hidden="true"
    className={styles.cardIcon}
  >
    {grid.map((row, ri) =>
      row.map((px, ci) =>
        px ? (
          <rect
            key={`${ri}-${ci}`}
            x={ci * PIXEL}
            y={ri * PIXEL}
            width={PIXEL}
            height={PIXEL}
            fill={color}
          />
        ) : null
      )
    )}
  </svg>
);

const Games = () => (
  <div className={styles.page}>
    {/* Header */}
    <motion.section
      className={styles.hero}
      initial="hidden"
      animate="visible"
      variants={fadeUp}
      transition={{ duration: 0.7 }}
    >
      <p className={styles.heroLabel}>ARCADE</p>
      <h1 className={styles.heroTitle}>Games</h1>
      <p className={styles.heroSub}>
        Classic arcade recreations — pixel-perfect sprites, authentic movement and original sound logic.
      </p>
    </motion.section>

    {/* Game cards */}
    <section className={styles.grid}>
      {GAMES.map(({ to, title, year, publisher, description, controls, grid, accentColor }, i) => (
        <motion.div
          key={to}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          transition={{ duration: 0.55, delay: i * 0.12 }}
        >
          <Link to={to} className={styles.card} style={{ '--accent': accentColor }}>
            {/* Sprite preview */}
            <div className={styles.cardIconWrap}>
              <GameIcon grid={grid} color={accentColor} />
            </div>

            {/* Meta */}
            <div className={styles.cardBody}>
              <div className={styles.cardMeta}>
                <span className={styles.cardYear}>{year}</span>
                <span className={styles.cardDot}>·</span>
                <span className={styles.cardPublisher}>{publisher}</span>
              </div>
              <h2 className={styles.cardTitle}>{title}</h2>
              <p className={styles.cardDesc}>{description}</p>

              {/* Controls */}
              <ul className={styles.controls}>
                {controls.map(c => (
                  <li key={c} className={styles.controlItem}>{c}</li>
                ))}
              </ul>
            </div>

            {/* Play CTA */}
            <div className={styles.cardFooter}>
              <span className={styles.playBtn}>Play →</span>
            </div>
          </Link>
        </motion.div>
      ))}
    </section>
  </div>
);

export default Games;
